
import env from "../../env.js"

export const url = env["solar-map-api"].url;


